import { EntertainmentSearchEffects } from './entertainment-search.effects';
import { EntertainmentDetailsSearchEffects } from './entertainment-ticket-details.effects';
import { EntertainmentTicketSearchEffects } from './entertainment-ticket-search.effects';

export const effects: any[] = [
  EntertainmentSearchEffects,
  EntertainmentTicketSearchEffects,
  EntertainmentDetailsSearchEffects,
];

export * from './entertainment-search.effects';
export * from './entertainment-ticket-details.effects';
export * from './entertainment-ticket-search.effects';
